import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface ProgressCardProps {
  label: string;
  uploaded: number;
  required: number;
  className?: string;
}

/**
 * Progress bar card showing ratio of completed / required items.
 */
export const ProgressCard = ({ label, uploaded, required, className }: ProgressCardProps) => {
  const pct = required > 0 ? Math.min(100, Math.round((uploaded / required) * 100)) : 0;

  return (
    <Card className={cn('min-w-0', className)}>
      <CardHeader className="pb-1 pt-3 px-4">
        <CardTitle className="text-xs font-medium text-efs-text-muted uppercase tracking-wide">
          {label}
        </CardTitle>
      </CardHeader>
      <CardContent className="px-4 pb-3 space-y-2">
        <div className="flex items-end justify-between">
          <span className="text-2xl font-semibold tabular-nums">{uploaded}</span>
          <span className="text-sm text-efs-text-muted">/ {required}</span>
        </div>
        <div className="h-2 w-full rounded-full bg-efs-bg-subtle overflow-hidden">
          <div
            className={cn(
              'h-full rounded-full transition-all',
              pct === 100 ? 'bg-efs-success' : pct > 0 ? 'bg-efs-warning' : 'bg-efs-bg-subtle',
            )}
            style={{ width: `${pct}%` }}
            role="progressbar"
            aria-valuenow={pct}
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>
      </CardContent>
    </Card>
  );
};
